"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalScript = void 0;
var finalScript = function (applicationId) {
    if (typeof window === "undefined") {
        return "";
    }
    var nrSet = false;
    var setNREUM = function () {
        var NREUM = window.NREUM;
        if (typeof NREUM === "undefined") {
            return "";
        }
        nrSet = true;
        NREUM.init = {
            distributed_tracing: { enabled: false },
            privacy: { cookies_enabled: true },
            jserrors: { enabled: true },
            page_view_timing: { enabled: false },
            session_trace: { enabled: false },
            ajax: { enabled: false },
            generic_events: { enabled: false },
            logging: { enabled: false },
            metrics: { enabled: false },
            performance: {
                capture_marks: false,
                capture_measures: false,
                capture_detail: false,
                resources: {
                    enabled: false,
                },
            },
            spa: { enabled: false },
            user_actions: { enabled: false },
            page_action: { enabled: false },
            session_replay: { enabled: false },
            soft_navigations: { enabled: false },
            harvest: {
                interval: 1,
            },
        };
        NREUM.loader_config = {
            accountID: "737486",
            trustKey: "737486",
            agentID: applicationId,
            licenseKey: "a9dd66e24a",
            applicationID: applicationId,
        };
        NREUM.info = {
            beacon: "bam.nr-data.net",
            errorBeacon: "bam.nr-data.net",
            licenseKey: "a9dd66e24a",
            applicationID: applicationId,
            sa: 1,
        };
    };
    setNREUM();
    window.addEventListener("newrelic", function (evt) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (evt.detail.loaded && !nrSet) {
            setNREUM();
        }
    });
};
exports.finalScript = finalScript;
